/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ session: NonNullable<unknown> }} Swap_Title_AddInputs */

const en_us2_swap_title_add = /** @type {(inputs: Swap_Title_AddInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Add to ${i?.session}`)
};

const pt_br2_swap_title_add = /** @type {(inputs: Swap_Title_AddInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Adicionar ao ${i?.session}`)
};

const es_419_swap_title_add = /** @type {(inputs: Swap_Title_AddInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Agregar a ${i?.session}`)
};

const pt_pt2_swap_title_add = /** @type {(inputs: Swap_Title_AddInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Adicionar ao ${i?.session}`)
};

const fr_fr2_swap_title_add = /** @type {(inputs: Swap_Title_AddInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ajouter à ${i?.session}`)
};

const de_de2_swap_title_add = /** @type {(inputs: Swap_Title_AddInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zu ${i?.session} hinzufügen`)
};

const it_it2_swap_title_add = /** @type {(inputs: Swap_Title_AddInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aggiungi a ${i?.session}`)
};

/**
* | output |
* | --- |
* | "Add to {session}" |
*
* @param {Swap_Title_AddInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const swap_title_add = /** @type {((inputs: Swap_Title_AddInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Swap_Title_AddInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_swap_title_add(inputs)
	if (locale === "es-419") return es_419_swap_title_add(inputs)
	if (locale === "pt-PT") return pt_pt2_swap_title_add(inputs)
	if (locale === "fr-FR") return fr_fr2_swap_title_add(inputs)
	if (locale === "de-DE") return de_de2_swap_title_add(inputs)
	if (locale === "it-IT") return it_it2_swap_title_add(inputs)
	return en_us2_swap_title_add(inputs)
});
export { swap_title_add as "swap.title_add" }